module.exports = __webpack_public_path__ + "img/grid-item-kynorelle.9c1aa2da.webp";